module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "ModalUpdatePage",
    attrs: {
      "id": "ModalUpdatePage"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [_c('h4', [_vm._v("Необходимо обновить страницу")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('h4', [_vm._v("\n            Привет " + _vm._s(_vm.user.firstname) + " "), _c('br'), _vm._v(" Приятная новость - Аларм План был обновлен\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Обновление необходимо для улучшения стабильности работы и добавления нового функционала.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Для стабильной работы необходимо обновить страницу. Рекомендуется обновить страницу с очисткой кеша нажав CTRL + F5 на клавиатуре.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Приносим свои извинения за доставленные не удобства.\n        ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatePage($event)
      }
    }
  }, [_vm._v("Обновить Аларм План")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-98a08a4a"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalUpdatePage.vue
// module id = 1061
// module chunks = 1